import { render, staticRenderFns } from "./Booking_details.vue?vue&type=template&id=0418f758&scoped=true&"
import script from "./Booking_details.vue?vue&type=script&lang=js&"
export * from "./Booking_details.vue?vue&type=script&lang=js&"
import style0 from "./Booking_details.vue?vue&type=style&index=0&id=0418f758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0418f758",
  null
  
)

export default component.exports